import { createFileRoute } from "@tanstack/react-router";

import { PublicationsList } from "./publications";

export const Route = createFileRoute("/_authenticated/studio/series")({
  head: () => ({
    meta: [
      { title: "Series — Creator Studio — Quibblies" },
      {
        name: "description",
        content:
          "Manage your serialised and multi-chapter writing on Quibblies, where chapters are reviewed independently before publishing.",
      },
      { property: "og:title", content: "Series — Quibblies Creator Studio" },
      { property: "og:description", content: "Manage serialised and multi-chapter writing." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: SeriesPage,
});

function SeriesPage() {
  return (
    <div className="space-y-4">
      <p className="rounded-2xl border border-border/60 bg-background/60 p-4 text-sm text-muted-foreground">
        Series and multi-chapter work publish chapter by chapter. Chapter one can be live while
        later chapters are still drafts or awaiting review.
      </p>
      <PublicationsList />
    </div>
  );
}
